
<div class="row">
    <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
        <div class="row align-items-center">
            <div class="col-12 my-2 fw-bold">
                Beer (Cans):
            </div>
            <file-attachment-list
                    [FileList]="marketingFiles.BeerCans"
                    [EditMode]="EditMode"
                    [UploadHandler]="FileUploader(MarketingFileType.BeerCans)"
                    [DeleteHandler]="FileDeleter()">
            </file-attachment-list>
        </div>
    </div>
    <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-2">
        <div class="row align-items-center">
            <div class="col-12 my-2 fw-bold">
                Beer (Draught):
            </div>
            <file-attachment-list
                    [FileList]="marketingFiles.BeerDraught"
                    [EditMode]="EditMode"
                    [UploadHandler]="FileUploader(MarketingFileType.BeerDraught)"
                    [DeleteHandler]="FileDeleter()">
            </file-attachment-list>
        </div>
    </div>
    <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
        <div class="row align-items-center">
            <div class="col-12 my-2 fw-bold">
                Spirits:
            </div>
            <file-attachment-list
                    [FileList]="marketingFiles.Spirits"
                    [EditMode]="EditMode"
                    [UploadHandler]="FileUploader(MarketingFileType.Spirits)"
                    [DeleteHandler]="FileDeleter()">
            </file-attachment-list>
        </div>
    </div>
</div>
<div class="row mt-4">
    <div class="col-12 text-center">
        <button type="button"
                class="btn btn-secondary"
                (click)="EditMode = !EditMode">
            {{EditMode ? 'Done Editing' : 'Edit Documents'}}
        </button>
    </div>
</div>